<template lang="html">
  <v-container
    fill-height
    fluid
    grid-list-xl>
    <v-layout
      justify-center
      wrap>
      <v-flex xs12>
        <stepper-card
          title="Plan New Trip"
          text="Follow the steps below to create a new quote"
          v-model="progress">

          <planner-step
            :complete="progress > 1"
            step='1'
            @continue="progress++"
            :clear="clearPayloads"
            :key="progress"/>

          <trip-step
            :complete="progress > 2"
            step="2"
            :planner="planner"
            @continue="getStops"
            :key="progress"/>

          <bus-step
            :complete='progress > 3'
            step='3'
            :stops="stops"
            :trip="trip"
            @continue="progress++"
            :loading="loading"
            :key="progress"/>

          <date-step
            :complete="progress > 4"
            step="4"
            :stops="stops"
            :trip="trip"
            :route="route"
            @continue="progress++"
            :loading="loading"
            :key="progress"/>

          <rate-step
            :complete="progress > 5"
            :trip="trip"
            step="5"
            @continue="getQuotes"
            :key="progress + 1"/>

          <summary-step
            :complete="progress > 6"
            step="6"
            :trip="trip"
            :stops="stops"
            :quote="quote">
            <template #actions>
              <v-btn
                color="primary"
                @click="createEmail(emailPayload).then(() => {
                  const message = `Confirmation email sent for trip: ${trip.id}`
                  const link = `/quotes/${quote.id}`
                  addNotification({ message, link })
                  }).catch( e => raiseError(e))">
                Send Confirmation
              </v-btn>
              <router-link :to="{
                name: 'Edit Trip',
                params: { id: quote.id}
              }">
                <v-btn color="info">
                  Edit
                </v-btn>
              </router-link>
              <v-btn color="secondary" @click="newQuote">
                New Quote
              </v-btn>
            </template>
          </summary-step>

        </stepper-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import StepperCard from '@/components/busie/StepperCard'
import TripPlannerStep from '@/components/busie/TripPlannerStep'
import TripStep from '@/components/busie/TripStep'
import TripDateStep from '@/components/busie/TripDateStep'
import QuoteSummaryStep from '@/components/busie/QuoteSummaryStep'
import RateStep from '@/components/busie/RateStep'
import TripBusStep from '@/components/busie/TripBusStep';

export default {
  components: {
    'stepper-card': StepperCard,
    'planner-step': TripPlannerStep,
    'trip-step': TripStep,
    'bus-step': TripBusStep,
    'date-step': TripDateStep,
    'rate-step': RateStep,
    'summary-step': QuoteSummaryStep
  },
  data: () => {
    return {
      progress: 1,
      loading: false,
      clearPayloads: false
    }
  },
  computed: {
    quotesQuerystring () {
      return `?trip__dispatch__id=${this.location}`
    },
    tripQuerystring () {
      return `?trip__id=${this.trip.id}`
    },
    emailPayload() {
      return { trip: this.trip.id, template: this.templateByType('a').id }
    },
    ...mapGetters('plan', [
      'planner',
      'trip',
      'route',
      'stops',
      'quote'
    ]),
    ...mapGetters('email-templates', { templateByType: 'byType' }),
    ...mapGetters('user', ['location']),
    ...mapGetters('dates', ['byDate'])
  },
  watch: {
    progress (val) {
      this.loading = false
    }
  },
  methods: {
    getStops () {
      return this.fetchStops(this.tripQuerystring).then(() => this.progress++)
    },
    getQuotes () {
      return this.fetchAll(this.quotesQuerystring).then(() => this.progress++)
    },
    newQuote () {
      this.clearData();
      this.progress = 1;
    },
    ...mapActions('plan', [
      'fetchStops',
      'clearData'
    ]),
    ...mapActions('emails', {createEmail: 'create'}),
    ...mapActions('app', ['raiseError', 'addNotification']),
    ...mapActions('quotes', ['fetchAll'])
  }
}
</script>

<style lang="css" scoped>
</style>
